import { X } from 'lucide-react'

interface Props {
  open: boolean
  onClose: () => void
  title: string
  children: React.ReactNode
  wide?: boolean
}

export default function SlideOver({ open, onClose, title, children, wide }: Props) {
  if (!open) return null

  return (
    <>
      <div className="fixed inset-0 bg-black/30 z-40" onClick={onClose} />
      <div className={`fixed inset-y-0 right-0 z-50 bg-white shadow-2xl flex flex-col transform transition-transform ${open ? 'translate-x-0' : 'translate-x-full'} w-full sm:${wide ? 'w-[600px]' : 'w-[480px]'}`}
        style={{ maxWidth: wide ? '600px' : '480px' }}>
        <div className="flex items-center justify-between px-4 sm:px-5 py-3 sm:py-4 border-b border-slate-200 shrink-0">
          <h2 className="font-semibold text-lg text-slate-900 truncate pr-2">{title}</h2>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600 p-2 -mr-1 min-w-[44px] min-h-[44px] flex items-center justify-center">
            <X size={20} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 sm:p-5 pb-safe">
          {children}
        </div>
      </div>
    </>
  )
}
